import React, { Fragment } from "react";
import {
  Autocomplete,
  Button,
  Container,
  Grid,
  MenuItem,
  Paper,
  Typography,
} from "@mui/material";
import { useMediaQuery } from "react-responsive";
import PageHeader from "../PageHeader";
import { Controller } from "react-hook-form";
import TextField from "@mui/material/TextField";
import Dropdown from "../basic/Dropdown";

const Test = ({ onSubmitClick, control, errors }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 600px)" });

  const attendingOptions = ["Yes", "No", "Maybe"];

  return (
    <Fragment>
      <PageHeader title={"Test"} />
      {isMobile === false && (
        <Container sx={{ mt: 8, mb: 8 }}>
          <Paper elevation={3} sx={{ mb: 6, p: 4 }}>
            <form>
              <Grid container spacing={3}>
                {/* Attending */}
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="attending"
                    control={control}
                    render={({ field }) => (
                      <Autocomplete
                        {...field}
                        options={attendingOptions}
                        getOptionLabel={(option) => option}
                        onChange={(event, value) => field.onChange(value)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Attending"
                            variant="outlined"
                            fullWidth
                            error={!!errors.attending}
                            helperText={errors.attending?.message}
                            InputProps={{
                              ...params.InputProps,
                              startAdornment: params.InputProps.startAdornment,
                              endAdornment: params.InputProps.endAdornment,
                            }}
                            sx={{ mb: 5 }}
                          />
                        )}
                        clearOnEscape
                        isOptionEqualToValue={(option, value) =>
                          option === value
                        }
                        sx={{
                          "& .MuiAutocomplete-option": { fontSize: "0.875rem" },
                        }}
                      />
                    )}
                  />
                </Grid>

                {/* Company Name */}
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="companyName"
                    control={control}
                    render={({ field, fieldState: { error, isDirty } }) => (
                      <TextField
                        label="Company Name"
                        variant="outlined"
                        fullWidth
                        {...field}
                        error={!!errors.companyName}
                        helperText={errors.companyName?.message}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Controller
                    name="email"
                    control={control}
                    render={({ field, fieldState: { error, isDirty } }) => (
                      <TextField
                        label="Email"
                        variant="outlined"
                        fullWidth
                        {...field}
                        error={!!errors.email}
                        helperText={errors.email?.message}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Controller
                    name="accountNumber"
                    control={control}
                    render={({ field, fieldState: { error, isDirty } }) => (
                      <TextField
                        label="Account Number"
                        variant="outlined"
                        fullWidth
                        {...field}
                        error={!!errors?.accountNumber}
                        helperText={errors?.accountNumber?.message}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Controller
                    name="guests"
                    control={control}
                    render={({ field, fieldState: { error, isDirty } }) => (
                      <TextField
                        label="Guests"
                        variant="outlined"
                        type="number"
                        fullWidth
                        {...field}
                        error={!!errors?.guests}
                        helperText={errors?.guests?.message}
                      />
                    )}
                  />
                </Grid>

                {/* Save Button */}
                <Grid item xs={12} textAlign="right">
                  <Button
                    size="small"
                    variant="contained"
                    color="error"
                    onClick={onSubmitClick}
                  >
                    Save
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Paper>
        </Container>
      )}
    </Fragment>
  );
};
export default Test;
